export default __webpack_public_path__ + "af4c6a1a3aa2b9b53f0b4b5aab3ac51d.svg";